export default __webpack_public_path__ + "static/media/daniel-capello.fd2f7d91.webp";